import { styled } from '@mui/material/styles';
import { TextField } from 'react-admin';

export const TextFieldStyled = styled(TextField)({
  cursor: 'pointer',
});
